import { MemberList } from "@/components/teams/member-list";
import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";

interface TeamMembersTabProps {
  teamId: string;
  currentUserId: string;
  onAddMember: () => void;
}

export function TeamMembersTab({ teamId, currentUserId, onAddMember }: TeamMembersTabProps) {
  return (
    <div className="space-y-4">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <h2 className="text-lg font-medium">Team Members</h2>
        <Button variant="outline" size="sm" onClick={onAddMember} className="w-full md:w-auto">
          <UserPlus className="mr-2 h-4 w-4" />
          Add Member
        </Button>
      </div>
      <MemberList teamId={teamId} currentUserId={currentUserId} />
    </div>
  );
}
